import { z } from 'zod';

import { languageCodeSchema } from '../internationalization';

export const userSettingsSchema = z.object({
    addSkillsBanner: z.enum(['disabled', 'enabled']),
    addSkillsProficiencyBanner: z.enum(['disabled', 'enabled']),
    jobNotifications: z.enum(['idle', 'disabled', 'enabled']).optional(),
    language: languageCodeSchema,
    startPage: z.string().optional(),
});

export type UserSettings = z.infer<typeof userSettingsSchema>;
